import React from 'react';
import { FaToggleOn, FaToggleOff } from 'react-icons/fa';
import PropTypes from 'prop-types';
import './LayoutBoxToggle.scss';

function LayoutBoxToggle(props) {
  const {
    title,
    active,
    onToggle,
  } = props;
  return (
    <div className="layout-box-toggle">
      <div className="layout-box-toggle__title">{title}</div>
      <div className="layout-box-toggle__icon" onClick={() => { onToggle(!active); }}>
        {active && <FaToggleOn />}
        {!active && <FaToggleOff />}
      </div>
    </div>
  );
}

LayoutBoxToggle.defaultProps = {
  title: '',
  active: false,
  onToggle: () => {},
};

LayoutBoxToggle.propTypes = {
  title: PropTypes.string,
  active: PropTypes.bool,
  onToggle: PropTypes.func,
};

export default LayoutBoxToggle;
